<div class="p-no-content">
  {{msg}}
</div>
